import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

/**
 * Async thunk to fetch VM status from API
 * @param {Object} payload
 * @param {string} payload.accountId - AWS account ID
 * @param {string} payload.vmId - VM ID
 */
export const getAWSVmStatus = createAsyncThunk(
  "awsVmStatus/getAWSVmStatus",
  async ({ accountId, id, tag }, { rejectWithValue }) => {
    try {
      // ✅ Replace with your actual API endpoint
      const response = await httpInterceptor.get(
        `/resources/aws/ec2-poll?account=${accountId}&instance=${id}&tag=${tag}`
      );

      // Example expected response:
      // { vmId: "i-1234567890", vmStatus: "running" }
      return response.data;
    } catch (error) {
      // Handle API error
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch VM status"
      );
    }
  }
);

const awsVmStatusSlice = createSlice({
  name: "awsVmStatus",
  initialState: {
    loading: false,
    statusResponse: null,
    error: false,
    errorMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAWSVmStatus.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.errorMessage = "";
      })
      .addCase(getAWSVmStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.statusResponse = action.payload;
      })
      .addCase(getAWSVmStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.errorMessage = action.payload;
      });
  },
});

export default awsVmStatusSlice.reducer;
